import {
  FinancialStatementResponseDto,
  FinancialStatementView,
} from "../../api/dto/FinancialStatement";

export interface HouseholdItem {
  id: "adults" | "childrenUnder16" | "children16to18" | "numberOfVehicles";
  value: number;
  label: string;
  maxValue: number;
  minValue: number;
}

export function buildHousehold(
  sfs: FinancialStatementView | null | undefined,
  max = {
    adults: 6,
    childrenUnder16: 8,
    children16to18: 8,
    numberOfVehicles: 5,
  },
  min = {
    adults: 1,
    childrenUnder16: 0,
    children16to18: 0,
    numberOfVehicles: 0,
  },
): HouseholdItem[] {
  if (sfs === null || sfs === undefined) {
    return [
      { id: "adults", value: min.adults || 1, label: "Adults", maxValue: max.adults, minValue: min.adults },
      { id: "childrenUnder16", value: min.childrenUnder16, label: "Children under 16", maxValue: max.childrenUnder16, minValue: min.childrenUnder16 },
      { id: "children16to18", value: min.children16to18, label: "Children 16 - 18", maxValue: max.children16to18, minValue: min.children16to18 },
      { id: "numberOfVehicles", value: min.numberOfVehicles, label: "Number of Vehicles", maxValue: max.numberOfVehicles, minValue: min.numberOfVehicles },
    ];
  }
  return [
    {
      id: "adults",
      value: typeof sfs.adults === "number" ? sfs.adults : 1,
      label: "Adults",
      maxValue: max.adults,
      minValue: min.adults,
    },
    {
      id: "childrenUnder16",
      value: typeof sfs.childrenUnder16 === "number" ? sfs.childrenUnder16 : 0,
      label: "Children under 16",
      maxValue: max.childrenUnder16,
      minValue: min.childrenUnder16,
    },
    {
      id: "children16to18",
      value: typeof sfs.children16to18 === "number" ? sfs.children16to18 : 0,
      label: "Children 16 - 18",
      maxValue: max.children16to18,
      minValue: min.children16to18,
    },
    {
      id: "numberOfVehicles",
      value:
        typeof sfs.numberOfVehicles === "number" ? sfs.numberOfVehicles : 0,
      label: "Number of Vehicles",
      maxValue: max.numberOfVehicles,
      minValue: min.numberOfVehicles,
    },
  ];
}

export function createAboutYou(sfs: FinancialStatementResponseDto) {
  return {
    adults: sfs?.adults ?? 0,
    childrenUnder16: sfs?.childrenUnder16 ?? 0,
    children16to18: sfs?.children16to18 ?? 0,
    customersEmploymentStatus: sfs?.customersEmploymentStatus ?? "",
    partnersEmploymentStatus: sfs?.partnersEmploymentStatus ?? "",
    homeStatus: sfs?.homeStatus ?? "",
    employmentType: sfs?.employmentType ?? 0,
    employmentTitle: sfs?.employmentTitle ?? 0,
    numberOfVehicles: sfs?.numberOfVehicles ?? 0,
  };
}
